export interface CarrierScac {
  scac: string;
  scacName: string;
  carrierId: string;
  carrierName: string;
  isActive: string;
  isDedicated: boolean;
  isBookingEligible: boolean;
  dataSource: string;
  effectiveDate: any;
  expirationDate: any;
  allowCounterOffer: boolean;
}
